<template>
  <div class="box">
    <!-- 左侧图片 -->
    <div :class="['left', leftStyle()]" v-if="!selectState.isCustom">
      <!-- 搜索 -->
      <!-- <div class="search flex_align">
        <div class="search_input flex_align">
          <el-autocomplete id="suggestId" style="width:100%;" v-model="search" :fetch-suggestions="querySearchAsync"
            placeholder="搜地点" @select="handleSelect"></el-autocomplete>
          <div class="search_x">×</div>
        </div>
        <div class="search_but" @click="query()">
          <img src="../assets/group/search.png" alt="" />
        </div>
      </div> -->
      <div class="tucheng flex_align">
        <div class="tucheng_box flex_align" style="width: 80px;padding-left: 5px;">
          <img src="../assets/map/dj.png" alt="" />
          <el-select class="tucheng_box_qb" style="flex:1;" v-model="onLineNum" placeholder="在线" @change="changeValue"
            :clearable="false">
            <el-option v-for="item in onLine" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="tucheng_box flex_align mouse" @click="changeMap(1)">
          <img v-if="isShow" src="../assets/map/xs.png" alt="" />
          <img v-else src="../assets/map/xs1.png" alt="" />
          {{ isShow ? "显示" : "隐藏" }}
        </div>
        <div class="tucheng_box flex_align mouse" @click="changeMap(2)">
          <img v-if="mapType" src="../assets/map/gj.png" alt="" />
          <img v-else src="../assets/map/gj1.png" alt="" />
          {{ mapType ? "默认" : "卫星" }}
        </div>
        <div class="tucheng_box flex_align mouse" @click="changeMap(3)">
          <img src="../assets/map/hld.png" alt="" />
          <span :class="isTraffic ? 'ls' : ''">路况</span>
        </div>
        <div class="tucheng_box flex_align" style="width: 80px; padding-left: 5px">
          <img src="../assets/map/aggregation.png" alt="" />
          <el-select
            class="tucheng_box_qb"
            style="flex: 1"
            v-model="aggregationId"
            @change="changeAggregation"
            :clearable="false"
          >
            <el-option
              v-for="item in aggregation"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="tucheng_box flex_align" id="targetBox" style="width: 120px;transform: translate(0, 0);" >
          <div style="width: 100%;padding-left: 5px;" class="flex_align" @click.stop="isCascader = !isCascader">
            <img src="../assets/map/terminalimg.png" alt="" />
            终端图标 <i class="el-icon-arrow-down" :class="isCascader?'el-icon-arrow-ax':''"></i>
          </div>
          <!-- <el-cascader-panel :options="options"></el-cascader-panel> -->
          <el-cascader-panel v-if="isCascader" popper-class="el-cascader-panel" v-model="cascaderArr" @change="handleChange" :props="propsConfig" :options="imgTab" :show-all-levels="false" >
            <template slot-scope="{ node, data }">
              <template v-if="data.img">
                <div class="flex_align">
                  <img :src="data.id=='1-0'?require('../assets/map/djj1.png'): xinextendUrlapi + data.img" alt="" />
                </div>
              </template>
              <span v-else>{{ node.label }}</span>
            </template>
          </el-cascader-panel>
        </div>
        <div class="tucheng_box flex_align" style="width: 100px;padding-left: 5px;">
          <img src="@/assets/map/gjb.png" alt="" />
          <!-- 工具箱 -->
          <el-select v-if="isMark" style="flex:1;" ref="loanStatusSelect" v-model="holdAllvalue" placeholder="工具箱">
            <el-option v-for="item in holdAll" :key="item.value" :label="item.label" :value="item.value">
              <div v-if="item.value != 2" @click.stop="mapHoldall(item.value)" class="flex_align"
                style="padding:0px 15px;">
                <!-- style="position: relative;" -->
                <img :src="item.img" style="width:19px;height:16px;margin-right:5px;" />
                <div>{{ item.label }}</div>
              </div>
              <el-popover popper-class="mark_popover" v-if="item.value == 2" transition="el-collapse-transition"
                placement="right-start" :open-delay="500" :offset="0" :close-delay="200" trigger="hover"
                :visible-arrow="false">
                <div slot="reference" @click.stop="mapHoldall(item.value)" class="flex_align" style="padding:0px 15px;">
                  <img :src="item.img" style="width:19px;height:16px;margin-right:5px;" />
                  <div>{{ item.label }}</div>
                </div>
                <div class="mark">
                  <div class="mouse mark_box flex_align" v-for="(items, index) in markList"
                    @click="oneselfPosition(items)" :key="index">
                    <img style="margin-right:5px;"
                      :src="items.img ? xinextendUrlapi + items.img : require('@/assets/map/mark.png')"
                      alt="" />
                    {{ items.name }}
                  </div>
                </div>
              </el-popover>
            </el-option>
          </el-select>
        </div>
        <div class="tucheng_box flex_align mouse" @click="changeMap('KML')" v-if="$store.state.userState.kmlMapSwitch">
          <img src="../assets/map/kml.png" alt="" />
          KML
        </div>
      </div>
      <div class="fangda mouse">
        <div class="fangda_icon" style="border-bottom: 1px solid #ccc;" @click="changeMap(4, true)">
          <img src="../assets/map/jh.png" alt="" />
        </div>
        <div class="fangda_icon" @click="changeMap(4, false)">
          <img src="../assets/map/jh1.png" alt="" />
        </div>
      </div>
      <div class="fangda_one flex_align mouse" @click="oneselfPosition()">
        <img src="../assets/map/dw1.png" alt="" />
      </div>
    </div>
    <!-- 右侧 -->
    <div :class="['overall', overallStyle()]">
      <div class="overall-vertical">
        <div class="horizontal mouse">
          <div class="overall-horizontal">
            <div :class="['icon', selectState.isCustom ? 'overall_one' : '']" style="position: relative;">
              <div class="icon_bg" v-if="draw.isPolygon" @click="getselectIcon(4, 1)">
                <img v-if="selectState.isCustom" src="../assets/map_zx1.png" alt="" />
                <img v-else src="../assets/map_zx.png" alt="" />
                <div class="triangle" @click.stop="bindSelect"></div>
              </div>
              <div class="icon_bg" v-if="draw.isCircular" @click="getselectIcon(5, 1)">
                <img v-if="selectState.isCustom" src="../assets/map_yx1.png" alt="" />
                <img v-else src="../assets/map_yx.png" alt="" />
                <div class="triangle" @click.stop="bindSelect"></div>
              </div>
              <!-- 方形 -->
              <div class="icon_bg" v-if="draw.isSquare" @click="getselectIcon(6, 1)">
                <img v-if="selectState.isCustom" src="../assets/map_fx1.png" alt="" />
                <img v-else src="../assets/map_fx.png" alt="" />
                <div class="triangle" @click.stop="bindSelect"></div>
              </div>
              <div class="Drawapicture" v-show="functionIconHeng">
                <div>
                  <img src="../assets/map_zx2.png" @click="getselectIcon(4)" alt="" />
                </div>
                <div>
                  <img src="../assets/map_yx2.png" @click="getselectIcon(5)" alt="" />
                </div>
                <div>
                  <img src="../assets/map_fx2.png" @click="getselectIcon(6)" alt="" />
                </div>
              </div>
            </div>
            <div class="icon">
              <div class="icon_bg" @click="getselectIcon(2)">
                <img src="../assets/map_fh.png" alt="" />
              </div>
            </div>
            <div class="icon">
              <div class="icon_bg" @click="getselectIcon(3)">
                <img src="../assets/map_sc.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对话框 -->
    <dialogbox ref="dialogbox" :dialogTitle="dialogTitle" :openGb="openGb" :width="dialogWidth"></dialogbox>

    <!-- kml设置 -->
    <dialogbox
      ref="dialogboxKML"
      :dialogTitle="'KML设置'"
      :setTingKMLShow="setTingKMLShow"
      :kmlList="kmlList"
      :width="'925px'"
      :butName="'添加'"
      @changeKML="changeKML"
      @getKMLlist="getKMLlist"
      @handleScrollKml="handleScrollKml"
      @isOpenAddKml="isOpenAddKml"
      @deleteKmlItem="deleteKmlItem"
      @isOpenEditKml="isOpenEditKml"
    ></dialogbox>

    <!-- kml添加 -->
    <dialogbox
      ref="dialogboxKMLAdd"
      :dialogTitle="'新增KML地图'"
      :width="'700px'"
      :butName="'确定'"
      :addKMLShow="addKMLShow"
      :fileList="fileList"
      @handleAvatarChange="handleAvatarChange"
      @handleRemove="handleRemove"
      @onSubemitAddKml="onSubemitAddKml"
    ></dialogbox>

    <!-- kml编辑 -->
    <dialogbox
      ref="dialogboxKMLEidt"
      :dialogTitle="'编辑KML地图'"
      :width="'700px'"
      :butName="'确定'"
      :editKMLShow="editKMLShow"
      :fileList="fileList"
      @handleAvatarChange="handleAvatarChange"
      @handleRemove="handleRemove"
      @onSubemitEditKml="onSubemitEditKml"
    ></dialogbox>

  </div>
</template>
<script></script>
<script>
import { getKMLlist,addKML,editKML,removeKML } from "@/administration/dispatchLntercom.js";
import dialogbox from "@/components/dispatchLntercom/dialogbox.vue";
import EventBus from "@/eventBus/eventBus.js";
import beasconfig from "@/api/beasconfig.js";
import { getQueryIcon } from "@/administration/upmarker.js";
// import { EleResize } from "../administration/esresize.js";
export default {
  components: {
    dialogbox
  },
  name: "mapcustomfence",
  props: {
    markList: {
          type: Array,
          default: function() {
			       return []
		      }
    }
  },
  data() {
    return {
      search: "",
      selectIcon: 0,
      functionIconHeng: false,
      functionIconSu: false,
      mapData: [
        //map搜索数据
        {
          value: "北京"
        },
        {
          value: "上海"
        },
        {
          value: "湖南"
        }
      ],
      timeout: null,
      holdAll: [
        //工具箱
        // {
        //   value: 0,
        //   label: "工具箱",
        //   img:require("@/assets/map/gjb.png"),
        //   imgBg:require("@/assets/map/gjb1.png")
        // },
        {
          value: 1,
          label: "测距",
          img:require("@/assets/map/cg.png"),
          imgBg:require("@/assets/map/cg1.png")
        },
        {
          value: 2,
          label: "标记",
          img:require("@/assets/map/bz.png"),
          imgBg:require("@/assets/map/bz1.png")
        }
      ],
      holdAllIndex:0,
      onLine: [
        //在线状态
        {
          label: "全部",
          value: 0
        },
        {
          label: "在线",
          value: 1
        },
        {
          label: "离线",
          value: 2
        }
      ],
      onLineNum: 1, //在线状态
      isShow: true, //显示 状态
      mapType: true, //地图显示类型
      isTraffic: false,
      holdAllvalue: "工具箱",
      openGb: false,
      dialogWidth: "956px", //对话框的宽度  50%
      dialogTableVisible: false,
      dialogTitle: "",
      selectState: {
        //
        isCustom: false, //自定义选中
        isReturn: false, //返回选中
        isDelete: false //删除选中
      },
      location: {
        lng: "",
        lat: ""
      },
      ac: {},
      draw:{
         isPolygon:true,
         isCircular:false,
         isSquare:false,
      },
      xinextendUrlapi: beasconfig.xinextendUrlapi + "/icon",
      isMark:true,
      aggregation: [
        {
          id: 1,
          name: "开启",
        },
        {
          id: 0,
          name: "关闭",
        },
      ],
      aggregationId: 1,
      imgTab: [
        {
          id: 0,
          label: "全部",
          isLeaf: true,
        },
        {
          id: 1,
          label: "通用",
          children: [],
        },
        {
          id: 2,
          label: "警保",
          children: [],
        },
        {
          id: 3,
          label: "消防",
          children: [],
        },
        {
          id: 4,
          label: "化工",
          children: [],
        },
        {
          id: 5,
          label: "其他",
          children: [],
        },
      ],
      propsConfig: {
        lazy: true,
        value: 'id',      // 对应数据中的 value 字段
        label: 'label',   // 对应显示文本字段
        leaf: 'isLeaf',    // 判断是否为叶子节点的字段
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          // console.log(node, 1111, level);
          if (level == 1) {
            let params = {
              orgId: this.$store.state.userInfo.org_id,
              category: 2,
              type: data.id,
            };
            getQueryIcon(params).then((res) => {
              let imgList = res.data.data;
              if (imgList) {
                imgList.forEach((item) => {
                  item.id = `${level}-${item.id}`
                  item.isLeaf = true;
                });
                resolve(imgList);
              }
            });
          }
        },
      },
      cascaderArr:[],
      isCascader:false,
      // markList:[],  //标记点集合

      kmlList:[],
      kmlPage: {
        pageNo: 1,
        pageSize: 20,
        total:0
      },
      setTingKMLShow:false,
      addKMLShow: false,
      isLoading:false,
      kmlName:"",//新增kml地图名称
      fileList:[],
      editKMLShow:false,
      editKMLItem:"",//点击编辑时，保存kml原对象
    };
  },
  created() {
    let that = this;
    that.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick);
  },
  filters: {},
  methods: {
    handleGlobalClick(e){
       const targetBox = document.getElementById('targetBox');
       if (!targetBox.contains(e.target)) {
        this.isCascader = false;
      }
    },
    handleChange(value){  //选中
      if(value[0] == 0 || value.length > 1){
        this.$emit("upterminalimg",this.cascaderArr)
        this.isCascader = false;
      }
    },
    handleSelects(key, keyPath) {
      console.log(key, keyPath);
    },
    changeAggregation(e) {
      this.$emit("changeAggregation", e);
      this.isCascader = false;
    },
    leftStyle(){
       let navId = this.$route.meta.navId;
       let cssStyle = 'mapleft';
       if(navId == 1){
          cssStyle = !this.$store.state.isLeftHome?'mapleft':'';
       }else{
          cssStyle = 'mapweilan';
       }
      return cssStyle;
    },
    overallStyle(){
       let navId = this.$route.meta.navId;
       let cssStyle = 'mapright';
       if(navId == 1){
          cssStyle = !this.$store.state.isRightHome?'mapright_tow':'mapright';
       }else{
          cssStyle = !this.$store.state.isDataAnalysis?'':'';
       }
      return cssStyle;
    },
    mapHoldall(e){   //改变地图
          // this.holdAllIndex = e;
          this.$refs.loanStatusSelect.visible = false
          // EventBus.$emit("mapHoldall",e)
          if(e == 1){
            this.$emit("changeMap", 5);
          }else if(e == 2){
            this.$emit("changeMap", 6);
          }
    },
    changeValue(e) {
      //选中值
      this.$emit("switchOnlineState", e, this.onLine[e].label);
    },
    changeMap(type, bool) {
      //改变地图
      if (type == 1) {  //改变地图状态
        this.isShow = !this.isShow;
        this.$emit("changeMap", type, this.isShow);
      } else if (type == 2) {  //切换地图类型
        this.mapType = !this.mapType; 
        this.$emit("changeMap", type, this.mapType);
      } else if (type == 3) {   //创建交通流量图层实例
        this.isTraffic = !this.isTraffic;
        this.$emit("changeMap", type, this.isTraffic);
      } else if (type == 4) {   //地图放大缩小
        this.$emit("changeMap", type, bool);
      } else if (type == 'KML') {
        //kml弹窗

        //初始化
        this.initKmlList()
        this.$refs.dialogboxKML.openkML()
      }
    },

    //打开编辑kml弹窗
    isOpenEditKml(item){
      this.editKMLShow = true;
      this.editKMLItem = item;
      this.fileList = [{
        ...item,
        name:item.filePath.match(/\/([^\/]+)$/)[1]
      }];
      this.$refs.dialogboxKMLEidt.openEditkML(item);
    },

    //编辑修改kml文件
    async onSubemitEditKml(kmlName,coordinate){
      if(kmlName === "" || kmlName === undefined){
        this.$MessageWarning('请输入KML地图名称');
        return
      }else if(coordinate === "" || coordinate === undefined){
        this.$MessageWarning('请选择坐标系');
        return
      }else if(this.fileList.length == 0){
        this.$MessageWarning('请上传KML地图文件');
        return
      }
      
      let obj = {
        id: this.editKMLItem.id,
        name: kmlName,
        coordinate:coordinate,
        display: this.editKMLItem.display,
      }

      //判断是否重新上传了文件
      if(this.fileList[0].raw){
        obj.raw = this.fileList[0].raw
      }else{
        obj.filePath = this.editKMLItem.filePath
      }

      //调用修改接口
      await this.checkKML(obj).then(()=>{

        this.$MessageSuccess('操作成功');
        this.$refs.dialogboxKMLEidt.gbDialog();
        setTimeout(() => {
          this.editKMLShow = false;
        }, 500);

        //编辑成功后，重新获取列表数据
        this.initKmlList()

      });

      
    },

    //确定上传kml文件
    onSubemitAddKml(kmlName,coordinate){
      if(kmlName === "" || kmlName === undefined){
        this.$MessageWarning('请输入KML地图名称');
        return
      }else if(coordinate === "" || coordinate === undefined ){
        this.$MessageWarning('请选择坐标系');
        return
      }else if(this.fileList.length == 0){
        this.$MessageWarning('请上传KML地图文件');
        return
      }
      
      if(this.isLoading){
        return
      }

      this.isLoading = true;

      let formData = new FormData();
      formData.append("uId", this.$store.state.userInfo.id);
      formData.append("name", kmlName);
      formData.append("coordinate", coordinate);
      formData.append("file", this.fileList[0].raw);

      addKML(formData).then(res=>{
        let data = res.data;
        if(data.code == 200){
          this.$MessageSuccess('操作成功');
          this.$refs.dialogboxKMLAdd.gbDialog();
          setTimeout(() => {
            this.addKMLShow = false;
            this.fileList = [];
          }, 500);
          this.initKmlList()
        }else{
            this.$MessageWarning(data.msg)
        }
        this.isLoading = false;
      })
    },

    //移除kml上传文件
    handleRemove(file, fileList){
      this.fileList = [];
    },

    //kml文件状态change事件
    handleAvatarChange(file, fileList){
      // console.log(file)
      const iskml = file.name.endsWith('.kml');
      const isLt100M = 0 < (file.size / 1024 / 1024) && (file.size / 1024 / 1024) <= 100;

      if (!iskml) {
          this.$MessageWarning('只支持kml格式文件，文件不能大于100MB');
          this.fileList = [];
          return
      } else if (!isLt100M) {
          this.$MessageWarning('只支持kml格式文件，文件不能大于100MB');
          this.fileList = [];
          return
      }

      this.fileList = [file];
    },

    //删除kml列表
    deleteKmlItem(item){
      this
        .$confirm("确定要删除KML文件吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let params = {
            id: item.id,
            uId: this.$store.state.userInfo.id
          }
          removeKML(params).then(res=>{
            let data = res.data;
            if(data.code == 200){
              console.log('删除kml文件成功');
              if(item.display){
                console.log('清空地图上的kml')
              }
              this.initKmlList()
            }else{
              this.$MessageWarning(data.msg)
            }
          })
        })
        .catch(() => {});
    },

    //打开添加kml弹窗
    isOpenAddKml(){
      this.addKMLShow = true;
      this.fileList = [];
      this.$refs.dialogboxKMLAdd.openAddkML()
    },

    //kml列表滚动事件
    handleScrollKml(){
      if (!this.isLoading && this.kmlList.length < this.kmlPage.total) {
        this.kmlPage.pageNo++;
        this.getKMLlist();
      }
    },

    //初始化kml列表
    initKmlList(){
      this.setTingKMLShow = true;
      this.kmlPage = {
        pageNo: 1,
        pageSize: 20,
        total:0
      }
      this.kmlValue = "";
      this.kmlList = [];
      this.getKMLlist()
    },

    //分页获取kml列表
    getKMLlist(){
        this.isLoading = true;

        let parmas = {
            pageNo:this.kmlPage.pageNo,
            pageSize:this.kmlPage.pageSize,
            uId:this.$store.state.userInfo.id
        }
        
        getKMLlist(parmas).then(res=>{
            let data = res.data;
            if(data.code == 200){
                this.kmlList = [...this.kmlList,...data.data.list];
                this.kmlPage.total = data.data.count;
            }else{
                this.$MessageWarning(data.msg)
            }
            this.isLoading = false;
        })
    },

    //kml列表弹窗界面的选择框选中事件
    async changeKML(value,id){
      let newItem = ""; //当前 选中 或 取消 的item
      let lastItem = "";  //上一个选中显示的item
      this.kmlList.forEach(item=>{
          if(id == item.id){
            newItem = item
          }
          if(id != item.id && item.display){
            item.display = false;
            lastItem = item;
          }
          if(id != item.id && value == true){
              item.display = false;
          }
      }) 

      //如果有，要请求接口取消上一次选择
      if(lastItem){
        this.checkKML(lastItem)
      }

      await  this.checkKML(newItem).then(()=>{
        this.$MessageSuccess('操作成功');
        setTimeout(() => {
          this.initKmlList()
        }, 500);
        //更新地图kml
        EventBus.$emit("updateKmlMapData");
      });

      
    },

    //显示/关闭kml地图
    checkKML(item){
      let formData = new FormData();
      formData.append("id", item.id);
      formData.append("uId", this.$store.state.userInfo.id);
      formData.append("name", item.name);
      formData.append("coordinate", item.coordinate);
      formData.append("display", item.display);
      if(item.filePath){
        formData.append("filePath", item.filePath);
      }else{
        formData.append("file", item.raw);
      }

      return  editKML(formData).then(res=>{
        let data = res.data;
        if(data.code == 200){
          console.log('显示/关闭kml地图成功')
        }
      })
    },

    bindSelect() {
      //选中
      if(this.selectState.isCustom){

        return
      }
      this.functionIconHeng = !this.functionIconHeng;
      // this.$emit("openDrawing");
    },
    getselectIcon(type,num) {
      // console.log("type", type);
      this.selectIcon = type;
      this.functionIconHeng = false;
      if(type >= 4 && this.selectState.isCustom){

        return
      }
      if (type == 1) {
        this.functionIconHeng = true;
        this.functionIconSu = true;
        this.$emit("openDrawing");
      } else if (type == 2) {
        this.selectState.isCustom = false;
        this.draw = {
          isPolygon:true,
          isCircular:false,
          isSquare:false,
       }
        this.$emit("previousStep");
      } else if (type == 3) {
        this.$emit("deleteFenceArea");
      } else if (type == 4) {
          if(num == 1 && this.selectState.isCustom){
            this.selectState.isCustom = false;
            this.$emit("openDrawing");
          }else{
            this.selectState.isCustom = true;
            this.draw = {
            isPolygon:true,
            isCircular:false,
            isSquare:false,
          }
          this.$emit("drawPolylines");
          }
      } else if (type == 5) {
        if(num == 1 && this.selectState.isCustom){
          this.selectState.isCustom = false;
          this.$emit("openDrawing");
        }else{
          this.selectState.isCustom = true;
          this.$emit("drawCircle");
            this.draw = {
              isPolygon:false,
              isCircular:true,
              isSquare:false,
          }
        }
      } else if (type == 6) {
        if(num == 1 && this.selectState.isCustom){
          this.selectState.isCustom = false;
          this.$emit("openDrawing");
        }else{
          this.selectState.isCustom = true;
          this.draw = {
              isPolygon:false,
              isCircular:false,
              isSquare:true,
          }
           this.$emit("drawRectangle");
        }
      }
    },
    oneselfPosition(row){    //当前位置
          EventBus.$emit('position',row);
          if(row){
            this.isMark = false;
            this.$nextTick(()=>{
              this.isMark = true;
            })
          }
    },
    bindOpenGb(title) {
      //显示广播
      if(this.selectState.isCustom){

        return
      }
      let groupArray = JSON.parse(sessionStorage.getItem("groupArray"));
      let array = groupArray.filter(item => item.isRadioBroadcast == true);
      if (array && array.length < 1) {
        this.$MessageWarning(`请先开启接收广播的群组`);
      } else {
        this.$refs.dialogbox.openPg(2);
        this.openGb = true;
        this.dialogWidth = "956px";
        this.dialogTitle = title;
      }
      EventBus.$emit("emptyMap",1);
    },
    querySearchAsync(queryString, cb) {
      // return
      if(queryString != ""){
        EventBus.$emit('searchMap',queryString)
      }
      var mapData = this.mapData;
      var results = queryString
        ? mapData.filter(this.createStateFilter(queryString))
        : mapData;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    query() {
      
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.left {
  position: absolute;
  top: 76px;
  left: 70px;
  z-index: 1100;

  .search {
    width: 455px;
    position: absolute;
    top: 10px;
    left: 10px;
    // width: 418px;
    height: 40px;
    overflow: hidden;
    background-color: #327676;
    border: 1px solid #327676;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 0px;

    &_x {
      width: 50px;
      height: 100%;
      line-height: 40px;
      border-left: 1px solid #e2e2e2;
      color: #ccc;
      font-size: 30px;
      font-weight: 400;
    }

    &_input {
      flex: 1;
      height: 100%;
      background-color: #fff;
      color: #696969 !important;

      /deep/.el-input__inner {
        width: calc(100% - 42px);
        // width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: var(--main-bg-color);
        color: #696969 !important;
        border: none;
        border-radius: 0px;
        padding: 0px;
      }
    }

    &_but {
      width: 58px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #327676;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 17px;
        height: 17px;
      }
    }
  }

  .tucheng {
    // width: 680px;
    // width: 600px;
    // width: 359px;
    height: 36px;
    background-color: #085A66;
    font-size: 14px;
    color: #ffffff;
    border-radius: 5px;
    // margin-top: 10px;
    position: relative;
    // overflow: hidden;

    &_box {
      // flex: 1;
      width: 70px;
      text-align: center;
      justify-content: center;
      height: 35px;
      border-right: 1px solid #e2e2e2;
      cursor: pointer;

      /deep/.el-input__inner {
        width: 100%;
        // width: 100%;
        height: 35px;
        line-height: 35px;
        background-color: #085A66;
        color: #ffffff !important;
        border: none;
        border-radius: 0px;
        padding: 0px;
      }

      img {
        width: 19px;
        height: 16px;
        margin-right: 2px;
      }
    }

    &_box:last-child {
      border: none;
    }
  }

  .fangda {
    width: 34px;
    height: 60px;
    font-size: 30px;
    background-color: #074F59;
    margin-top: 10px;
    border-radius: 5px;
    color: #ffffff;
    margin-top: 10px;

    &_icon {
      width: 85%;
      height: 30px;
      line-height: 20px;
      margin: auto;
      // img{
      //   width: 25;
      // }
    }
  }

  .fangda_one {
    width: 34px;
    height: 34px;
    margin-top: 15px;
    background-color: #074F59;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.overall_weilan {
  right: 430px !important;
}

.overall {
  position: absolute;
  top: 26px;
  right: 395px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1100;

  .horizontal {
    display: flex;
    align-items: center;

    .mian-body {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border: 1px solid #c2c2c2;
      border-radius: 4px;
    }

    .overall-horizontal {
      width: 190px;
      height: 40px;
      overflow: hidden;
      display: flex;
      align-items: center;
      background: #0A7684;
      margin-left: 8px;
      border: 1px solid #0A7684;
      border-radius: 5px;
      // box-shadow: 0 0 5px 0px #0A7684;

      .overall_one {
        background-color: #0A7684;
      }

      .icon {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #e2e2e2;
        position: relative;

        &:last-child {
          border: none;
        }

        &:hover {
          background-color: #4BFAF8;
        }

        .Drawapicture {
          position: fixed;
          // bottom: -115px;
          z-index: 1101;
          display: flex;
          flex-direction: column;
          border-radius: 5px;
          overflow: hidden;
          margin-top: 160px;

          div {
            width: 40px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #0A7684;
            border-bottom: 1px solid #e2e2e2;
          }

          div:last-child {
            border: none;
          }

          img {
            width: 20px;
            height: 20px;
          }
        }

        &_bg {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          // overflow: hidden;
          .triangle {
            width: 0px;
            border-style: solid;
            border-color: transparent;
            border-width: 8px 8px 8px 8px;
            border-right-color: #ffffff;
            border-bottom-color: #ffffff;
            opacity: 1;
            margin: auto;
            position: absolute;
            right: 0px;
            bottom: 0px;
          }

          img {
            width: 25px;
            height: 25px;
          }
        }

        .ace1 {
          background: url("../assets/map_zx.png");
          background-size: 100% 100%;
        }

        .ace2 {
          background: url("../assets/map_fh.png");
          background-size: 100% 100%;
        }

        .ace3 {
          background: url("../assets/map_sc.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 5px;
  left: 0;
  display: flex;
  align-items: flex-end;

  &_left {
    position: fixed;
    bottom: 0px;
    left: 55%;

    .triangle {
      width: 0px;
      border-style: solid;
      border-color: transparent;
      border-width: 8px 8px 8px 8px;
      border-top-color: #414447;
      opacity: 1;
      margin: auto;
      position: relative;

      &_border {
        width: 0px;
        border-style: solid;
        border-color: transparent;
        border-width: 9px 9px 9px 9px;
        border-top-color: #4affff;
        position: absolute;
        top: -8px;
        left: -9px;
        z-index: -1;
      }
    }

    .bottom_ptt {
      width: 107px;
      height: 107px;
      margin: auto;
    }
  }

  &_popup {
    width: 180px;
    height: 40px;
    line-height: 40px;
    padding: 0px 10px;
    text-align: center;
    position: relative;
    background-color: #414447;
    opacity: 0.9;
    border-radius: 5px;
    border: 1px solid #4affff;
    top: -15px;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #ffffff;
  }

  &_tz {
    width: 48px;
    height: 48px;
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
}

.mark {
  min-width: 125px;
  max-height: 180px;
  background-color: #ffffff;
  overflow: auto;
  // padding: 10px 0px;

  // position: absolute;
  // right: 0px;
  // top: 0px;
  &>div:hover {
    background-color: #e2e2e2;
  }

  &::-webkit-scrollbar {
    width: 6px;
    height: 100%;
    background-color: #fff;
  }

  &::-webkit-scrollbar-track {
    width: 6px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
  }

  &>div {
    padding: 5px 10px;

    &>img {
      width: 25px;
      height: 25px;
    }
  }
}

.ls {
  color: #4fd17d;
}

.flex_align {
  display: flex;
  align-items: center;
}

/deep/ .el-cascader-panel{
  position: fixed;
  top: 40px;
  left: 0px;
  background-color: #ffffff;
  z-index: 100;

  & img{
    width: 25px !important;
    height: 25px !important;
  }

  .el-cascader-menu{
    min-width: 120px;
  }
}
.el-icon-arrow-down{
  position: absolute;
  right: 5px;
  transition: transform .3s;
  transform: rotateZ(0deg);
}

.el-icon-arrow-ax{
  transition: transform .3s;
  transform: rotateZ(180deg);
}
</style>

<style>
.mark_popover {
  min-width: 120px !important;
  padding: 0px !important;
  margin-left: 20px !important;
}
</style>